<!-- Card with hover + tap behaviour -->
<div class="card h-100"
     [class]="cardClass"
     style="position:relative;cursor:pointer;touch-action:manipulation;"
     (mouseenter)="showHover()"
     (mouseleave)="hideHover()"
     (click)="toggleTap($event)">

  <ng-container *ngTemplateOutlet="bodyTpl"></ng-container>

  <!-- Desktop hover popover — has its own mouseenter/mouseleave so the
       6 px gap between card top and popover bottom doesn't close it -->
  <div *ngIf="hovered && !tapped && popupTpl"
       class="d-none d-sm-block"
       style="position:absolute;bottom:calc(100% + 6px);left:50%;
              transform:translateX(-50%);min-width:180px;z-index:200;"
       (mouseenter)="showHover()"
       (mouseleave)="hideHover()">
    <div class="card shadow-lg border p-2">
      <ng-container *ngTemplateOutlet="popupTpl"></ng-container>
    </div>
  </div>

</div>

<!-- Full-screen tap overlay (mobile + desktop click) -->
<div *ngIf="tapped && (tapTpl || popupTpl)"
     style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:1055;
            background:rgba(0,0,0,0.45);
            display:flex;align-items:center;justify-content:center;
            padding:24px;box-sizing:border-box;"
     (click)="closeTap()">
  <div class="card shadow-lg border p-3"
       [style.width]="'100%'"
       [style.max-width]="popupMaxWidth"
       style="max-height:calc(100vh - 48px);overflow-y:auto;box-sizing:border-box;"
       (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeTap()">✕</button>
    </div>
    <ng-container *ngTemplateOutlet="tapTpl ?? popupTpl ?? null"></ng-container>
  </div>
</div>
